import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=0410d15d"
import script from "./RulesTable.vue?vue&type=script&lang=js"
export * from "./RulesTable.vue?vue&type=script&lang=js"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=0410d15d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports